import { render, staticRenderFns } from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=template&id=2e21405c&scoped=true&"
import script from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=style&index=0&id=2e21405c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21405c",
  null
  
)

export default component.exports